import { useSelector } from "react-redux";

const DEFAULT_CURRENCY = "TND";

// 1. Make sure this is exported
export const CURRENCY_MAP = {
  TND: {
    code: "TND",
    symbol: "TND",
    name: "Tunisian Dinar",
    decimalPlaces: 3,
  },
  EUR: {
    code: "EUR",
    symbol: "€",
    name: "Euro",
    decimalPlaces: 2,
  },
  USD: {
    code: "USD",
    symbol: "$",
    name: "US Dollar",
    decimalPlaces: 2,
  },
};

// 2. Export an array of the values for easy mapping in dropdowns
export const AVAILABLE_CURRENCIES = Object.values(CURRENCY_MAP);

export const useCurrency = () => {
  const company = useSelector((state) => state.company?.company);
  const rawCurrency = company?.companyCurrency || DEFAULT_CURRENCY;

  const currencyCode =
    rawCurrency === "€"
      ? "EUR"
      : rawCurrency === "$"
      ? "USD"
      : rawCurrency?.toUpperCase?.() || DEFAULT_CURRENCY;

  return CURRENCY_MAP[currencyCode] || CURRENCY_MAP[DEFAULT_CURRENCY];
};

export default useCurrency;